var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"iframe-modal"}},[_c('iframe',{attrs:{"src":_vm.data.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }